const isClose = (one: number, other: number, tolerance: number) => {
  return Math.abs(one - other) < tolerance
}

export default isClose
